'use strict';

/* Constants for working with Products. */

exports.PriceTypes = {
	Tiered: 'tiered',
	Range: 'range'
};
